export default "__VITE_ASSET__BINT3lwN__"